import './variables.css';
import './carousel.css';
import './icon.css';
import './navigation.css';
import './pagination.css';
import './slide.css';
